import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AuthLayout } from "../components/AuthLayout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await resetPassword(email);
    setLoading(false);
    if (error) {
      toast.error(error.message);
      return;
    }
    setSent(true);
    toast.success("Reset link sent.");
  };

  return (
    <AuthLayout title="Reset your password" subtitle="We'll email you a secure link to set a new password." testId="forgot-password-page">
      {sent ? (
        <div className="rounded-md border border-accent/30 bg-emerald-50 p-6" data-testid="forgot-success-message">
          <div className="flex items-start gap-3">
            <MailCheck className="mt-0.5 h-6 w-6 shrink-0 text-accent" />
            <div>
              <p className="font-medium text-slate-900">Check your email</p>
              <p className="mt-1 text-sm text-slate-600">
                If an account exists for <span className="font-medium">{email}</span>, a password reset link is on its way.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-password-form">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@clinic.com" data-testid="forgot-email-input" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Send reset link
          </Button>
        </form>
      )}
      <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline" data-testid="back-to-login-link">
        <ArrowLeft className="h-4 w-4" /> Back to sign in
      </Link>
    </AuthLayout>
  );
}
